import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M16.5 8.5v1h-9v-1h9zm0 2v1h-9v-1h9zm-5 2v1h-4v-1h4zm7-8h-13v15h13v-15zm1-1v17h-15v-17h15z'],
  height: 24,
  width: 24,
});
